import React from "react";
import { Link } from "react-router-dom";

const CommonBreadcrumb = ({
  title,
  breadcrumbs = [],

  // Single Button
  buttonText,
  buttonIcon,
  buttonLink,
  onButtonClick,

  // Multiple Buttons
  buttons = [],

  // Optional Link
  linkText,
  linkUrl,
}) => {
  return (
    <div className="page-header-breadcrumb all_breadcrumb">
      <div className="page_heading_breadcrumb">
        <nav>
          <h4 className="fw-semibold">{title}</h4>

          <ol className="breadcrumb mb-0">
            {breadcrumbs.map((item, index) => (
              <li
                key={index}
                className={`breadcrumb-item ${
                  index === breadcrumbs.length - 1 ? "active" : ""
                }`}
              >
                {item.link && index !== breadcrumbs.length - 1 ? (
                  <Link to={item.link}>{item.label}</Link>
                ) : (
                  item.label
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>

      <div className="d-flex align-items-center gap-2">

        {linkText && linkUrl && (
          <Link to={linkUrl} className="btn btn-outline-primary">
            {linkText}
          </Link>
        )}

        {/* Multiple Buttons */}
        {buttons.length > 0
          ? buttons.map((btn, index) =>
              btn.link ? (
                <Link
                  key={index}
                  to={btn.link}
                  className={btn.className || "btn btn-primary"}
                >
                  {btn.icon}
                  {btn.text}
                </Link>
              ) : (
                <button
                  key={index}
                  type="button"
                  className={btn.className || "btn btn-primary"}
                  onClick={btn.onClick}
                >
                  {btn.icon}
                  {btn.text}
                </button>
              )
            )
          : buttonText &&
            (buttonLink ? (
              <Link to={buttonLink} className="btn btn-primary">
                {buttonIcon}
                {buttonText}
              </Link>
            ) : (
              <button
                type="button"
                className="btn btn-primary"
                onClick={onButtonClick}
              >
                {buttonIcon}
                {buttonText}
              </button>
            ))}
      </div>
    </div>
  );
};

export default CommonBreadcrumb;